(function() {
  function sanitizeHandle(handle) {
    if (!handle) return '';
    return handle.replace(/[^a-z0-9\-\_]/gi, '');
  }

  // Centralized backend URL — set via theme.liquid bridge (window.KZ_BACKENDS).
  // Usado apenas pelo trackEvent (analytics POST).
  var API_BASE = (window.KZ_BACKENDS && window.KZ_BACKENDS.modalRec) || 'https://kz-recommendations.vercel.app';
  var STORE = 'global';

  var KEY_MAP = {
    'retorno': 'stage',
    'mixagem': 'mixing',
    'guitarra': 'guitar',
    'baixo': 'bass',
    'bateria': 'drums',
    'teclado': 'keyboard',
    'vocal': 'vocal',
    'outros': 'other',
    'standard-fit': 'standard-fit',
    'smaller-fit': 'smaller-fit',
    'not-sure': 'standard-fit',
    'equilibrado': 'balanced',
    'graves': 'bass',
    'energetico': 'energetic',
    'eletronica': 'electronic',
    'rock': 'rock',
    'hiphop': 'hiphop',
    'classica': 'classical',
    'pop': 'pop',
    'gospel': 'gospel',
    'diversos': 'various',
    'edicao': 'editing',
    'streaming': 'streaming',
    'cinema': 'cinema',
    'animacao': 'animation',
    'fps': 'fps',
    'rpg': 'rpg',
    'moba': 'moba',
    'casual': 'casual',
    'audiovisual': 'audiovisual',
    'games': 'games'
  };

  var FALLBACK_PRODUCTS = {
    'stage-guitar-standard-fit': ['kz-as16-pro-16-balanced-drivers-iem-earphones', 'new-kz-castor-pro'],
    'stage-bass-standard-fit': ['kz-zar-16-drivers-iem-earphones', 'new-kz-castor-pro'],
    'stage-drums-standard-fit': ['new-kz-zsx-pro-12-drivers-iem-earphones', 'new-kz-castor-pro'],
    'stage-keyboard-standard-fit': ['kz-as16-pro-16-balanced-drivers-iem-earphones', 'new-kz-d-fi-precision-tuned-iem-earphones'],
    'stage-vocal-standard-fit': ['kz-za12-new-professional-12-drivers-hybrid-earphones', 'kz-zsn-pro-2'],
    'stage-other-standard-fit': ['kz-as16-pro-16-balanced-drivers-iem-earphones', 'new-kz-castor-pro'],
    'stage-guitar-smaller-fit': ['kz-zs10-pro-2', 'new-kz-castor-pro'],
    'stage-bass-smaller-fit': ['kz-zs10-pro-2', 'kz-castor-hybrid-iem-earphone'],
    'stage-drums-smaller-fit': ['kz-zs10-pro-2', 'kz-castor-hybrid-iem-earphone'],
    'stage-keyboard-smaller-fit': ['kz-zs10-pro-2', 'kz-zna-12mm'],
    'stage-vocal-smaller-fit': ['kz-zs10-pro-2', 'kz-zsn-pro-2'],
    'stage-other-smaller-fit': ['kz-zs10-pro-2', 'new-kz-castor-pro'],
    'casual-balanced': ['kz-zsn-pro-2', 'new-kz-castor-pro', 'new-kz-carol-anc-true-wireless-earphone'],
    'casual-bass': ['kz-castor-hybrid-iem-earphone', 'kz-zsx-12-drivers-iem-earphones', 'kz-sa08-pro-tws-true-wireless-bluetooth-5-2'],
    'casual-energetic': ['kz-zs10-pro-x', 'kz-zsn-pro-x-dual-driver-iem-earphones', 'kz-sks-hybrid-wireless-earphones-5-2'],
    'mixing-electronic': ['new-kz-sonata-28ba-units-hifi-iem-earphones', 'kz-as16-pro-16-balanced-drivers-iem-earphones'],
    'mixing-rock': ['new-kz-sonata-28ba-units-hifi-iem-earphones', 'kz-as16-pro-16-balanced-drivers-iem-earphones'],
    'mixing-hiphop': ['new-kz-as24-pro-24-ba-units-hifi-earphones', 'kz-as16-pro-16-balanced-drivers-iem-earphones'],
    'mixing-classical': ['new-kz-sonata-28ba-units-hifi-iem-earphones', 'kz-as16-pro-16-balanced-drivers-iem-earphones'],
    'mixing-pop': ['new-kz-sonata-28ba-units-hifi-iem-earphones', 'kz-as16-pro-16-balanced-drivers-iem-earphones'],
    'mixing-gospel': ['new-kz-as24-pro-24-ba-units-hifi-earphones', 'kz-as16-pro-16-balanced-drivers-iem-earphones'],
    'mixing-various': ['new-kz-as24-pro-24-ba-units-hifi-earphones', 'kz-as16-pro-16-balanced-drivers-iem-earphones'],
    'audiovisual-editing': ['kz-as16-pro-16-balanced-drivers-iem-earphones', 'kz-zsn-pro-2'],
    'audiovisual-streaming': ['kz-zsn-pro-2', 'kz-zna-12mm'],
    'audiovisual-cinema': ['kz-as16-pro-16-balanced-drivers-iem-earphones', 'kz-zna-12mm'],
    'audiovisual-animation': ['kz-zna-12mm', 'kz-as16-pro-16-balanced-drivers-iem-earphones'],
    'games-fps': ['kz-edx-pro-dynamic-driver-gaming-earphones', 'new-kz-zs10-pro-2-gaming-earphones', 'kz-sora-tws-anc-bluetooth-5-4'],
    'games-rpg': ['kz-edx-pro-dynamic-driver-gaming-earphones', 'kz-zsn-pro-x-dual-driver-gaming-earphones', 'kz-sora-tws-anc-bluetooth-5-4'],
    'games-moba': ['kz-edx-pro-dynamic-driver-gaming-earphones', 'new-kz-zs10-pro-2-gaming-earphones', 'kz-sora-tws-anc-bluetooth-5-4'],
    'games-casual': ['kz-edx-pro-dynamic-driver-gaming-earphones', 'new-kz-zs10-pro-2-gaming-earphones', 'kz-sora-tws-anc-bluetooth-5-4']
  };

  var quizData = null;
  var currentStep = 0;
  var userAnswers = {};
  var questionHistory = [];

  var qs = function(s) { return document.querySelector(s); };
  var qsa = function(s) { return document.querySelectorAll(s); };

  function translateKey(key) {
    return KEY_MAP[key] || key;
  }

  function getLegacyFitKey(key) {
    if (!key) return '';
    if (key.endsWith('-smaller-fit')) {
      return key.replace('-smaller-fit', '-female');
    }
    if (key.endsWith('-standard-fit')) {
      return key.replace('-standard-fit', '-male');
    }
    return '';
  }

  // Le metafield kz_modal.quiz renderizado SSR pelo Liquid.
  // Pure sync read — script asset roda com defer apos HTML parsed.
  function loadQuizData() {
    try {
      var el = document.getElementById('kz-modal-quiz-data');
      if (!el) return;
      var raw = el.textContent.trim();
      if (!raw || raw === 'null') return;
      var parsed = JSON.parse(raw);
      var data = (parsed && typeof parsed === 'object' && parsed.data) ? parsed.data : parsed;
      if (data && Object.keys(data).length > 0) {
        quizData = data;
      }
    } catch (e) {}
  }

  function trackEvent(event, handle, title) {
    fetch(API_BASE + '/api/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event: event, store: STORE, handle: handle || null, title: title || null }),
      keepalive: true
    }).catch(function() {});
  }

  function resetCouponDisplay() {
    var el = qs('#couponCodeEl');
    if (!el) return;
    el.textContent = (el.dataset.code || '').trim() || el.textContent.trim();
    el.classList.remove('coupon-copied');
  }

  // --- CUPOM: le codigo e textos traduzidos direto dos data-attributes ---
  window.copyCoupon = function() {
    var el = qs('#couponCodeEl');
    if (!el) return;
    var code = (el.dataset.code || el.textContent || '').trim();
    navigator.clipboard.writeText(code).then(function() {
      var copiedText = (el.dataset.copied || '✓ Copied!').trim();
      el.textContent = copiedText;
      el.classList.add('coupon-copied');
      setTimeout(function() {
        el.textContent = code;
        el.classList.remove('coupon-copied');
      }, 2000);
    }).catch(function() {
      alert(((el.dataset.alert || 'Coupon: ').trim() + ' ') + code);
    });
  };

  function scrollToActiveQuestion() {
    setTimeout(function() {
      var activeQuestion = qs('.quiz-question.active');
      if (!activeQuestion) return;
      var rootStyles = getComputedStyle(document.documentElement);
      var headerHeight = parseInt(rootStyles.getPropertyValue('--header-height'), 10) || 0;
      var offset = headerHeight + 24;
      var top = activeQuestion.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }, 100);
  }

  function updateStepDots() {
    var maxQuestions = getQuizQuestionCount();
    qsa('.step-dot').forEach(function(dot, idx) {
      dot.classList.toggle('is-hidden', idx >= maxQuestions);
      dot.classList.remove('visible');
    });
  }

  function getQuizQuestionCount() {
    if (!userAnswers.purpose) return 3;
    return userAnswers.purpose === 'retorno' ? 3 : 2;
  }

  function updateProgress() {
    var progressContainer = qs('.progress-container');
    if (progressContainer) progressContainer.classList.remove('is-hidden');

    var maxQuestions = getQuizQuestionCount();
    var progress = Math.min(((currentStep + 1) / maxQuestions) * 100, 100);
    qs('#progressFill').style.width = progress + '%';

    updateStepDots();

    qsa('.step-dot').forEach(function(dot, idx) {
      if (dot.classList.contains('is-hidden')) return;
      dot.classList.toggle('active', idx <= currentStep);
      dot.classList.toggle('completed', idx < currentStep);
    });
  }

  window.goBack = function() {
    if (!questionHistory.length) return;
    var prev = questionHistory.pop();
    qsa('.quiz-question').forEach(function(q) { q.classList.remove('active'); });
    qs('.quiz-results').classList.remove('active');
    qs('[data-question="' + prev + '"]').classList.add('active');
    scrollToActiveQuestion();

    if (prev === '1') {
      currentStep = 0;
      userAnswers = {};
    } else if (prev.startsWith('2-')) {
      currentStep = 1;
      delete userAnswers.preference;
      delete userAnswers.fit;
    } else if (prev === '3-retorno') {
      currentStep = 2;
      delete userAnswers.fit;
    }
    updateProgress();
  };

  function nextQuestion(answer) {
    var currQ = qs('.quiz-question.active').getAttribute('data-question');
    questionHistory.push(currQ);

    if (currentStep === 0) {
      userAnswers.purpose = answer;
      currentStep = 1;
      trackEvent('quiz_start');
    } else if (currentStep === 1) {
      userAnswers.preference = answer;
      currentStep = userAnswers.purpose === 'retorno' ? 2 : 3;
    } else if (currentStep === 2) {
      userAnswers.fit = answer;
      currentStep = 3;
    }

    qsa('.quiz-question').forEach(function(q) { q.classList.remove('active'); });

    if (currentStep === 1) {
      var nextQ = qs('[data-question="2-' + userAnswers.purpose + '"]');
      if (nextQ) nextQ.classList.add('active');
      scrollToActiveQuestion();
    } else if (currentStep === 2 && userAnswers.purpose === 'retorno') {
      var retornoQ = qs('[data-question="3-retorno"]');
      if (retornoQ) retornoQ.classList.add('active');
      scrollToActiveQuestion();
    } else if (currentStep === 3) {
      showResults();
      return;
    }
    updateProgress();
  }

  function formatPrice(price, currency) {
    var p = parseFloat(price);
    if (currency === 'USD') return '$' + p.toFixed(2);
    if (currency === 'EUR') return '€' + p.toFixed(2);
    if (currency === 'GBP') return '£' + p.toFixed(2);
    return currency + ' ' + p.toFixed(2);
  }

  // --- Render product card via DOM API (XSS-safe) ---
  function createProductCard(product, delay) {
    var variantId = product.variantId || '';
    var variantNumericId = variantId.toString().includes('/') ? variantId.split('/').pop() : variantId;
    var safeHandle = sanitizeHandle(product.handle);
    var price = product.price || '0';
    var currency = product.currency || 'USD';

    var card = document.createElement('div');
    card.className = 'product-card';
    card.dataset.product = safeHandle;
    card.dataset.price = String(price);
    card.dataset.currency = currency;
    card.dataset.variant = String(variantNumericId);
    card.style.animationDelay = delay + 's';

    var imageWrapper = document.createElement('div');
    imageWrapper.className = 'product-image-wrapper';
    var img = document.createElement('img');
    img.src = product.image || 'https://placehold.co/400x300/1a1a2e/17d4e6?text=KZ';
    img.alt = product.name || '';
    img.className = 'product-image';
    img.loading = 'lazy';
    imageWrapper.appendChild(img);

    var info = document.createElement('div');
    info.className = 'product-info';

    var titleEl = document.createElement('h4');
    titleEl.className = 'product-title';
    if (window.KZVariantPicker && typeof window.KZVariantPicker.setTitle === 'function') {
      window.KZVariantPicker.setTitle(titleEl, product.name || '');
    } else {
      titleEl.textContent = product.name || '';
    }

    var priceEl = document.createElement('div');
    priceEl.className = 'product-price';
    priceEl.textContent = formatPrice(price, currency);

    var descEl = document.createElement('div');
    descEl.className = 'product-description';
    descEl.textContent = product.description || '';

    var buttonsDiv = document.createElement('div');
    buttonsDiv.className = 'product-buttons';

    var cartBtn = document.createElement('button');
    cartBtn.type = 'button';
    cartBtn.className = 'product-button add-to-cart-btn';
    cartBtn.textContent = addToCartText;
    cartBtn.dataset.variant = String(variantNumericId);
    cartBtn.dataset.handle = safeHandle;
    cartBtn.dataset.title = product.name || '';
    cartBtn.dataset.price = String(price);
    cartBtn.dataset.currency = currency;
    cartBtn.addEventListener('click', function() {
      quizSmartAddToCart(this);
    });

    var viewBtn = document.createElement('a');
    viewBtn.href = '/products/' + safeHandle;
    viewBtn.className = 'product-button view-product-btn';
    viewBtn.textContent = viewMoreText;
    viewBtn.addEventListener('click', function() {
      trackEvent('quiz_click', safeHandle, product.name);
    });

    buttonsDiv.appendChild(cartBtn);
    buttonsDiv.appendChild(viewBtn);

    info.appendChild(titleEl);
    info.appendChild(priceEl);
    info.appendChild(descEl);
    info.appendChild(buttonsDiv);

    card.appendChild(imageWrapper);
    card.appendChild(info);

    return card;
  }

  var addToCartText = window.kzQuizI18n.addToCartText;
  var addedText = window.kzQuizI18n.addedText;
  var viewMoreText = window.kzQuizI18n.viewMoreText;

  window.addToCartAjax = async function(variantId, handle, title, price, currency, btn) {
    var originalText = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (response.ok) {
        trackEvent('quiz_atc', handle, title);

        if (typeof fbq === 'function') {
          fbq('track', 'AddToCart', {
            content_ids: [variantId],
            content_name: title,
            content_type: 'product',
            currency: currency || 'USD',
            value: parseFloat(price) || 0
          });
        }

        if (typeof gtag === 'function') {
          gtag('event', 'add_to_cart', {
            currency: currency || 'USD',
            value: parseFloat(price) || 0,
            items: [{
              item_id: variantId,
              item_name: title,
              price: parseFloat(price) || 0,
              quantity: 1
            }]
          });
        }

        btn.textContent = addedText;

        var cartResponse = await fetch('/cart.js');
        var cart = await cartResponse.json();

        ['cart:refresh', 'theme:cart:change'].forEach(function(e) {
          document.documentElement.dispatchEvent(new CustomEvent(e, { bubbles: true, detail: { cart: cart } }));
        });
        document.dispatchEvent(new CustomEvent('cart:build'));

        window.scrollTo({ top: 0, behavior: 'smooth' });

        setTimeout(function() {
          var drawer = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer, [data-drawer-id="cart-drawer"]');
          if (drawer && drawer.open) { drawer.open(); return; }
          if (window.theme && window.theme.cartDrawer && window.theme.cartDrawer.open) { window.theme.cartDrawer.open(); return; }

          var cartIcon = document.querySelector('.Header__Icon--cart, [data-cart-trigger], [href="/cart"][data-action="open-drawer"], .header__cart-icon');
          if (cartIcon) cartIcon.click();
        }, 300);

        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);

      } else {
        throw new Error('Error');
      }
    } catch (e) {
      btn.textContent = 'Error';
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    }
  };

  /* Quiz add-to-cart with variant picker.
     The quiz only stores the first variant id on each card, so for
     multi-variant products it would silently add an arbitrary variant
     when the customer expects to choose. This wrapper fetches the
     full product on click, opens the shared KZVariantPicker dialog
     when there are real options, and falls back to the legacy direct
     add when the product has only the default variant (or when the
     fetch / picker fails). */
  function quizSmartAddToCart(button) {
    var handle = button.dataset.handle;
    var variantId = button.dataset.variant;
    var title = button.dataset.title || '';
    var price = button.dataset.price || '';
    var currency = button.dataset.currency || '';
    var originalText = button.textContent;

    function fallbackDirect() {
      addToCartAjax(variantId, handle, title, price, currency, button);
    }

    if (!handle || !window.KZVariantPicker || typeof window.KZVariantPicker.openDialog !== 'function') {
      fallbackDirect();
      return;
    }

    button.disabled = true;
    button.textContent = '...';

    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (productJs) {
        button.disabled = false;
        button.textContent = originalText;

        if (!productJs.variants || productJs.variants.length <= 1) {
          fallbackDirect();
          return;
        }

        window.KZVariantPicker.openDialog(
          window.KZVariantPicker.fromProductJs(productJs),
          {
            onAdded: function (variant) {
              var pickedPrice = (variant && variant.priceCents != null)
                ? (variant.priceCents / 100)
                : (parseFloat(price) || 0);
              var pickedId = variant && variant.id;
              trackEvent('quiz_atc', handle, title);
              if (typeof fbq === 'function') {
                fbq('track', 'AddToCart', {
                  content_ids: [pickedId],
                  content_name: title,
                  content_type: 'product',
                  currency: currency || 'USD',
                  value: pickedPrice
                });
              }
              if (typeof gtag === 'function') {
                gtag('event', 'add_to_cart', {
                  currency: currency || 'USD',
                  value: pickedPrice,
                  items: [{
                    item_id: pickedId,
                    item_name: title,
                    price: pickedPrice,
                    quantity: 1
                  }]
                });
              }
            }
          }
        );
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = originalText;
        fallbackDirect();
      });
  }

  async function showResults() {
    var progressContainer = qs('.progress-container');
    if (progressContainer) progressContainer.classList.add('is-hidden');

    qsa('.quiz-question').forEach(function(q) { q.classList.remove('active'); });
    qs('.quiz-results').classList.add('active');
    resetCouponDisplay();

    trackEvent('quiz_complete');

    var purpose = translateKey(userAnswers.purpose);
    var preference = translateKey(userAnswers.preference);
    var fit = userAnswers.fit ? translateKey(userAnswers.fit) : null;

    var key = userAnswers.purpose === 'retorno'
      ? purpose + '-' + preference + '-' + fit
      : purpose + '-' + preference;

    var results = qs('#recommendedProducts');
    results.textContent = '';
    var spinner = document.createElement('div');
    spinner.className = 'loading-spinner';
    spinner.textContent = 'Loading recommendations...';
    results.appendChild(spinner);

    var products = [];

    if (quizData && quizData[key] && quizData[key].length > 0) {
      products = quizData[key];
    } else if (quizData && getLegacyFitKey(key) && quizData[getLegacyFitKey(key)] && quizData[getLegacyFitKey(key)].length > 0) {
      products = quizData[getLegacyFitKey(key)];
    } else {
      var handles = FALLBACK_PRODUCTS[key] || FALLBACK_PRODUCTS['casual-balanced'];
      products = handles.map(function(handle) { return { handle: handle, name: handle, fallback: true }; });
    }

    if (products.length === 0) {
      results.textContent = '';
      var noResults = document.createElement('p');
      noResults.style.cssText = 'text-align:center;color:#9ca3af;';
      noResults.textContent = 'No products found.';
      results.appendChild(noResults);
      return;
    }

    if (products[0].fallback) {
      results.textContent = '';
      var productData = document.getElementById('product-data');
      if (productData) {
        products.forEach(function(p, idx) {
          var safeHandle = sanitizeHandle(p.handle);
          var card = productData.querySelector('[data-product="' + safeHandle + '"]');
          if (card) {
            var clone = card.cloneNode(true);
            clone.style.display = 'block';
            clone.style.animationDelay = (idx * 0.1) + 's';
            results.appendChild(clone);

            // Attach event listeners to cloned buttons
            var cartBtn = clone.querySelector('.add-to-cart-btn');
            if (cartBtn) {
              cartBtn.addEventListener('click', function() {
                quizSmartAddToCart(this);
              });
            }
            var viewBtn = clone.querySelector('.view-product-btn');
            if (viewBtn) {
              viewBtn.addEventListener('click', function() {
                var c = this.closest('.product-card');
                if (c) trackEvent('quiz_click', c.dataset.product, c.querySelector('.product-title') ? c.querySelector('.product-title').textContent : '');
              });
            }
          }
        });
      }
      if (results.children.length === 0) {
        var notFound = document.createElement('p');
        notFound.style.cssText = 'text-align:center;color:#9ca3af;';
        notFound.textContent = 'Products not found. Please check back later.';
        results.appendChild(notFound);
      }
    } else {
      var pathParts = window.location.pathname.split('/');
      var localePrefix = (pathParts[1] && pathParts[1].length === 2) ? '/' + pathParts[1] : '';

      var translatedProducts = await Promise.all(products.map(async function(p) {
        try {
          var safeHandle = sanitizeHandle(p.handle);
          var res = await fetch(localePrefix + '/products/' + safeHandle + '.json');
          if (res.ok) {
            var data = await res.json();
            var shopifyProduct = data.product;
            var variant = shopifyProduct.variants && shopifyProduct.variants[0];
            return {
              handle: p.handle,
              name: shopifyProduct.title || p.name,
              description: shopifyProduct.body_html ? shopifyProduct.body_html.replace(/<[^>]*>/g, '').substring(0, 150) + '...' : (p.description || ''),
              image: shopifyProduct.images && shopifyProduct.images[0] ? shopifyProduct.images[0].src : p.image,
              price: variant ? (variant.price / 1).toString() : p.price,
              variantId: variant ? variant.id.toString() : p.variantId,
              currency: window.kzQuizI18n.currency
            };
          }
        } catch (e) {}
        return p;
      }));

      results.textContent = '';
      translatedProducts.forEach(function(p, idx) {
        results.appendChild(createProductCard(p, idx * 0.1));
      });
    }

    setTimeout(function() {
      var resultsSection = qs('.quiz-results');
      if (!resultsSection) return;
      var top = window.scrollY + resultsSection.getBoundingClientRect().top - 170;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }, 300);
  }

  window.restartQuiz = function() {
    currentStep = 0;
    userAnswers = {};
    questionHistory = [];
    updateProgress();
    qs('.quiz-results').classList.remove('active');
    qsa('.quiz-question').forEach(function(q) { q.classList.remove('active'); });
    qs('[data-question="1"]').classList.add('active');
    qs('.quiz-header').scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  document.addEventListener('DOMContentLoaded', function() {
    loadQuizData();

    qsa('.quiz-option').forEach(function(option) {
      option.addEventListener('click', function() {
        var value = this.getAttribute('data-value');
        var self = this;
        self.style.transform = 'scale(0.95)';
        setTimeout(function() {
          self.style.transform = '';
          nextQuestion(value);
        }, 120);
      });
    });

    // Attach copyCoupon via addEventListener instead of inline onclick
    var couponEl = qs('#couponCodeEl');
    if (couponEl) {
      couponEl.addEventListener('click', function() {
        window.copyCoupon();
      });
    }

    updateProgress();
  });
})();
